import React from "react";
import stylesLess from "./index.module.less";

import { Modal, ModalFuncProps } from "antd";
import XtSvg from "../xt/svg";
type ModalType = "info" | "success" | "error" | "warning" | "confirm";
interface Props extends ModalFuncProps {
  isDark?: boolean;
  inner?: React.ReactNode;
  type?: ModalType;
  center?: boolean;
}
const svgNameMap = {
  info: "warning", // 旋转180度
  success: "modal-success",
  error: "modal-error",
  warning: "warning",
  confirm: "warning",
};
function ModelAlert({ isDark = false, className, title, content, inner, center = false, centered = true, icon, type = "info", ...rest }: Props) {
  const csn = `${stylesLess.main} ${isDark ? "dark" : "light"} ${className}`;
  return Modal[type]({
    title: false,
    icon: icon === false ? icon : icon || <XtSvg icon={svgNameMap[type]} />,
    content: (
      <div className={"iBody"}>
        {title && (
          <div className={"iTitle"} style={{ textAlign: center ? "center" : "left" }}>
            {title}
          </div>
        )}
        {content && (
          <div className={"iContent"} style={{ textAlign: center ? "center" : "left" }}>
            {content}
          </div>
        )}
        {inner && <div className={"iInner"}>{inner}</div>}
      </div>
    ),
    centered,
    className: csn,
    ...rest,
  });
}

["info", "success", "error", "warning", "confirm"].forEach((v) => {
  ModelAlert[v] = (props: Props | string) => {
    let params = {} as Props;
    if (typeof props === "string") {
      params = { content: props, type: v as Props["type"] };
    } else {
      params = { ...props, type: v as Props["type"] };
    }
    return ModelAlert(params);
  };
});

type InstanceProps = {
  [key in ModalType]: (props: Props | string) => ReturnType<typeof ModelAlert>;
};
interface ModalAlertProps extends InstanceProps {
  function(props: Props): ReturnType<typeof ModelAlert>;
}
export default ModelAlert as unknown as ModalAlertProps;
